{{#not billing_same_as_service }}
<div class="row mt1">
    <div class="col desktop--col-50 col-100">
      <label for="billing-address-first-name">First Name*</label>
      <input id="billing-address-first-name" value="{{ billing.first_name }}" name="billing.first_name" type="text" autocorrect="off" placeholder="Johnny">
    </div>
    <div class="col desktop--col-50 col-100">
      <label for="billing-address-last-name">Last Name*</label>
      <input id="billing-address-last-name" value="{{ billing.last_name }}" name="billing.last_name" type="text" autocorrect="off" placeholder="Appleseed">
    </div>
  </div>
  <div class="row">
    <div class="col col-100">
      <label for="billing-address-address">Address*</label>
      <input id="billing-address-address" value="{{ billing.line1 }}" name="billing.line1" type="text" autocorrect="off" placeholder="123 Main St">
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-33 col-100">
      <label for="bililng-address-apt">Apt / Suite #</label>
      <input id="biling-address-apt" value="{{ billing.line2 }}" name="billing.line2" type="text" autocorrect="off" placeholder="10">
    </div>
    <div class="col desktop--col-66 col-100">
      <label for="billing-address-city">City / Town*</label>
      <input id="billing-address-city" value="{{ billing.city }}" name="billing.city" type="text" autocorrect="off" placeholder="Leominster">
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-33 col-100">
      <label for="billing-address-state">State*</label>
      <input id="billing-address-state" value="{{ billing.state }}" name="billing.state" type="text" autocorrect="off" autocapitalize="characters" placeholder="MA" maxlength="2">
    </div>
    <div class="col desktop--col-33 col-100">
      <label for="billing-address-zip">Zip*</label>
      <input id="billing-address-zip" value="{{ billing.zip }}" name="billing.zip" type="number" autocorrect="off" placeholder="01453">
    </div>
    <div class="col desktop--col-33 col-100">
      <label for="billing-address-phone">Phone*</label>
      <input id="billing-address-phone" value="{{ billing.phone }}" name="billing.phone" type="tel" autocorrect="off" placeholder="555-555-5555">
    </div>
  </div>
{{/not}}
